class TipoAditivoEnum {
    constructor(cod, desc) {
      this.cod = cod;
      this.desc = desc;
    }
  
    static fromcod(cod) {
      return Object.values(TipoAditivoEnum).find(status => status.cod === cod);
    }
  
    static fromDesc(desc) {
      return Object.values(TipoAditivoEnum).find(status => status.desc === desc);
    }
  }
  
  TipoAditivoEnum.ACRESCIMO_VALOR = new TipoAditivoEnum(1, "Acréscimo de Valor");
  TipoAditivoEnum.SUPRESSAO = new TipoAditivoEnum(2, "Supressão");
  TipoAditivoEnum.PRORROGACAO_PRAZO = new TipoAditivoEnum(3, "Prorrogação de Prazo");
  TipoAditivoEnum.REPACTUACAO = new TipoAditivoEnum(4, "Repactuação");
  TipoAditivoEnum.REEQUILIBRIO_ECONOMICO_FINANCEIRO = new TipoAditivoEnum(5, "Reequilíbrio Econômico-Financeiro");
  TipoAditivoEnum.OUTRAS_ALTERACOES = new TipoAditivoEnum(6, "Outras alterações contratuais");



  export default TipoAditivoEnum;